import React from "react";
import useAdminSalesStats from "../hooks/useAdminSalesStats";
import AdminSalesStats from "../components/AdminSalesStats";

const AdminSalesStatsInterface = () => {
  const {
    periodType,
    startDate,
    endDate,
    stats,
    loading,
    handlePeriodTypeChange,
    handleStartDateChange,
    handleEndDateChange,
    handleApplyFilters,
    handleRefresh,
  } = useAdminSalesStats();

  return (
    <AdminSalesStats
      stats={stats}
      periodType={periodType}
      startDate={startDate}
      endDate={endDate}
      onPeriodTypeChange={handlePeriodTypeChange}
      onStartDateChange={handleStartDateChange}
      onEndDateChange={handleEndDateChange}
      onApplyFilters={handleApplyFilters}
      onRefreshData={handleRefresh}
      loading={loading}
    />
  );
};

export default AdminSalesStatsInterface;
